import { IActionErrorDescription } from '../../../../samwebDescription/samweb/notification/IActionErrorDescription';

export function ActionErrorDescription(errorDescription: IActionErrorDescription) {
   // tslint:disable-next-line:only-arrow-functions ban-types
   return function (Class: Function) {
      Object.defineProperty(Class.prototype, 'actionErrorDescriptionFromDecorator', {
         value: errorDescription,
      });
   };
}
